module.exports = __webpack_public_path__ + "static/media/boarding_point_departure_time.70bc3cd9.svg";